import type { NuxtApp } from '#app';

/**
 * The API client for the current request (see plugins/fetch.ts). Call it synchronously at the top of setup,
 * a store or a util: on the server the Nuxt context is gone after the first await.
 */
export const useApi = (): NuxtApp['$api'] => useNuxtApp().$api;
